<div *ngIf="!link && active" class="tab">
  <ng-content></ng-content>
</div>
